import { Component, Inject, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Parameter } from 'src/app/models/parameter.model';
import { ParameterService } from 'src/app/services/parameter.service';
import { Router } from '@angular/router';

export interface DeleteBlockedDialogData {
  parameter: Parameter;
  initialSensorCount?: number;
}

export interface LinkedSensorAssignment {
  id: string;
  sensorName: string;
  location?: string;
  status?: string;
}

@Component({
  standalone: false,
  selector: 'app-parameter-delete-blocked-dialog',
  templateUrl: './parameter-delete-blocked-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./parameter-delete-blocked-dialog.component.scss']
})
export class ParameterDeleteBlockedDialogComponent implements OnInit, OnDestroy {
  linkedSensors: LinkedSensorAssignment[] = [];
  isLoading = false;
  loadError = false;
  sensorCount = 0;
  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<ParameterDeleteBlockedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteBlockedDialogData,
    private parameterService: ParameterService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (this.data?.parameter?.id) {
      // Seed the sensor count from the caller (we know there's at least 1 since the dialog was only shown due to active assignments)
      this.sensorCount = this.data.initialSensorCount || 1;
      this.loadLinkedSensors(this.data.parameter.id);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadLinkedSensors(parameterId: string): void {
    this.isLoading = true;
    this.loadError = false;
    this.parameterService.getLinkedSensorAssignments(parameterId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (sensors: LinkedSensorAssignment[]) => {
          this.linkedSensors = sensors || [];
          this.sensorCount = this.linkedSensors.length;
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          this.loadError = true;
          // sensorCount remains at its seeded value (initialSensorCount or 1)
        }
      });
  }

  navigateToSensorAssignments(): void {
    this.dialogRef.close();
    this.router.navigate(['/dashboard/sensor-assignments']);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
